import { Navigate } from 'react-router'
import { useAuth } from '@m3-tech/boss-core'
import AccessDenied from '@/pages/AccessDenied'
import { resolveSettingsLandingRoute } from '@/constants/settingsLanding'

/**
 * Resolves the Settings index ("/") landing based on the user's features and security
 * groups, mirroring the legacy React 15 `getEntryRoute()` priority. Redirects to the
 * user's first accessible section, or renders Access Denied when nothing is accessible.
 */
export function SettingsIndexRedirect() {
    const { features, securityGroups } = useAuth()
    const landing = resolveSettingsLandingRoute(features, securityGroups)

    if (!landing) return <AccessDenied />
    return <Navigate to={landing} replace />
}
